import axios from "axios";

import { getToken } from "../utils/cookies";

const erpRequest = axios.create({
  baseURL: process.env.REACT_APP_ERP_SYNC_BLUEPRINT_API,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    accept: "application/json",
  },
});

export const initERPApiInterceptors = () => {
  erpRequest.interceptors.request.use(
    (config) => {
      config.headers["Authorization"] = `Bearer ${getToken()}`;
      return config;
    },
    (error) => {
      console.error("Error in initERPApiInterceptors", error);
      return Promise.reject(error);
    }
  );
};

////////////////////////////////////////////////////////////////////////////////////////////////////

export async function getAllBlueprints() {
  return erpRequest("/blueprint");
}

export async function getBlueprintByUuid(uuid) {
  return erpRequest("/blueprint/" + uuid);
}

export async function createBlueprint(data) {
  return erpRequest({
    method: "post",
    url: "/blueprint",
    data: data,
  });
}

export async function updateBlueprint(uuid, data) {
  return erpRequest({
    method: "patch",
    url: "/blueprint/" + uuid,
    data: data,
  });
}

export async function updateBlueprintMemo(data) {
  return erpRequest({
    method: "patch",
    url: "/blueprint/memo/" + data["uuid"],
    data: data["memo"],
  });
}
